import {
  ButtonSecondary,
  ButtonSize,
  PermissionEnum,
  formatPhone,
} from '@ui/src';
import GeneralUserInfoRow from './general-user-info-row';
import { GeneralUserInfoContactsTypes } from '../types';

import cn from '../styles.module.css';

const GeneralUserInfoContacts = ({
  control,
  baseUserInformation,
  recoveryInProgress,
  onResetPassword,
  edit,
  activePermissions,
}: GeneralUserInfoContactsTypes) => (
  <div className={cn.generalUserInfoBlock}>
    <div className={cn.generalUserInfoBlockItem}>
      <GeneralUserInfoRow title="Password" type="default">
        {activePermissions?.includes(PermissionEnum.USERS_EDIT_ACTION) ? (
          <ButtonSecondary
            size={ButtonSize.SMALL}
            className={`button-white ${cn.passwordButton}`}
            text={
              recoveryInProgress
                ? 'Loading...'
                : 'Submit a password reset request'
            }
            onClick={onResetPassword}
          />
        ) : (
          '*********'
        )}
      </GeneralUserInfoRow>
    </div>
    <div className={cn.generalUserInfoBlockItem}>
      <GeneralUserInfoRow
        title="Phone number"
        control={control}
        type="text"
        disabled
        name="phone"
        defaultValue={
          (baseUserInformation?.phone
            ? formatPhone(baseUserInformation?.phone)
            : '') || '-'
        }
        withCopy
      />
      <GeneralUserInfoRow
        title="Email"
        control={control}
        type="text"
        disabled={!edit}
        name="email"
        defaultValue={baseUserInformation?.email || '-'}
        zIndex={5}
        withCopy={!edit}
      />
    </div>
  </div>
);

export default GeneralUserInfoContacts;
